import type { PortfolioCollectionCalculationsMode } from "@repo/shared/types";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./correlation-empty-state.i18n";

type CorrelationEmptyStateProps = {
  mode: PortfolioCollectionCalculationsMode;
};

export function CorrelationEmptyState({ mode }: CorrelationEmptyStateProps) {
  const t = useT(T)[mode];

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t.title}</CardTitle>
        <CardDescription>{t.description}</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground text-center py-8">{t.emptyMessage}</p>
      </CardContent>
    </Card>
  );
}
